module.exports = __webpack_public_path__ + "static/media/icon4@2x.0d00af4d.png";